import React from 'react';
import { icons } from '../../../configs/Icons';
import cn from '../../utils/cn';

export function UserCardV1({ title, subTitle, icon, hide, className, iconSize }) {
    return (
        <div className={cn('user-card-v1 w-full flex flex-row items-center gap-3', className)}>
            {!hide && (
                <div
                    className={cn('overflow-hidden h-11 w-11 min-w-[44px] rounded-full', iconSize)}
                >
                    <img
                        src={icon || icons.defaultAvatar}
                        alt=""
                        className="w-full h-full block object-cover object-top"
                    />
                </div>
            )}
            <div className="flex flex-col items-start justify-center text-left overflow-hidden w-full">
                {title && (
                    <h1 className="text-primary text-base font-medium overflow-hidden text-ellipsis whitespace-nowrap w-full">
                        {title}
                    </h1>
                )}
                {subTitle && (
                    <p className="text-primary-700 text-sm font-normal overflow-hidden text-ellipsis whitespace-nowrap w-full">
                        {subTitle}
                    </p>
                )}
            </div>
        </div>
    );
}

export function UserCardV2({ title, subTitle, icon, hide, className, iconSize }) {
    return (
        <div className={cn('user-card-v2 w-full flex flex-row items-center gap-3', className)}>
            {!hide && (
                <div
                    className={cn(
                        'overflow-hidden h-11 w-11 min-w-[44px] rounded-full border border-primary-100',
                        iconSize
                    )}
                >
                    <span className="w-full h-full block">
                        <img
                            src={icon || icons.defaultAvatar}
                            alt=""
                            className="w-full h-full block object-cover object-top"
                        />
                    </span>
                </div>
            )}
            <div className="flex flex-col items-start justify-center text-left overflow-hidden w-full">
                {title && (
                    <h1 className="text-primary text-base font-medium  overflow-hidden text-ellipsis whitespace-nowrap w-full">
                        <span>{title}</span>
                    </h1>
                )}
                {subTitle && (
                    <p className="text-secondary text-sm font-normal overflow-hidden text-ellipsis whitespace-nowrap w-full">
                        <span>{subTitle}</span>
                    </p>
                )}
            </div>
        </div>
    );
}

export function UserCardV3({ title, subTitle, icon, hide, className, iconSize }) {
    return (
        <div
            className={cn(
                'user-card-v3 w-full flex flex-row items-center gap-3 overflow-hidden',
                className
            )}
        >
            {!hide && (
                <div
                    className={cn('overflow-hidden h-11 w-11 min-w-[44px] rounded-full', iconSize)}
                >
                    <img
                        src={icon || icons.defaultAvatar}
                        alt={title || 'avatar'}
                        className="w-full h-full block object-cover object-top "
                    />
                </div>
            )}
            <div className="flex flex-col items-start justify-center text-left overflow-hidden w-full">
                {title && (
                    <h1 className="text-primary-700 text-sm font-normal overflow-hidden text-ellipsis w-full whitespace-nowrap">
                        {title}
                    </h1>
                )}
                {subTitle && (
                    <p className="text-primary text-base font-medium overflow-hidden text-ellipsis whitespace-nowrap w-full">
                        {subTitle}
                    </p>
                )}
            </div>
        </div>
    );
}

export default null;
